import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import {
  CaseStudyBanner,
  ContactFormFullwidth,
  FullwidthImage,
} from 'components';
import { enableAnimations } from 'config/helpers';
import {
  Banner,
  Problem,
  Stages,
  CollaborationProcess,
  AcrossIndustries,
  OurArticles,
  OtherServices,
} from './subcomponents';
import './FullProductDevelopmentCycle.scss';

class FullProductDevelopmentCycle extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query {
            polcoLogo: file(relativePath: { eq: "logos/polco-white.png" }) {
              childImageSharp {
                fluid(maxWidth: 150) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            polcoMockupImage: file(
              relativePath: { eq: "fpdc/polco-app-mockup-mood.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1150) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            fullwidthImage: file(
              relativePath: {
                eq: "fpdc/two-woman-having-online-meeting-with-client.jpg"
              }
            ) {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={data => (
          <div className={'single-page single-page--hero fpdc'}>
            <Banner />
            <Problem />
            <Stages />
            <LazyLoad offset={200}>
              <CaseStudyBanner
                link={'/blog/case-study-polco/'}
                color={'green'}
                textColor={'white'}
                image={data.polcoMockupImage.childImageSharp.fluid}
                logo={data.polcoLogo.childImageSharp.fluid}
                client={'Polco'}
                title={
                  'How Polco.us used the lean startup approach to deliver a voting platform.'
                }
                tags={['javascript', 'lean', 'user-centered']}
              />
            </LazyLoad>
            <LazyLoad offset={200}>
              <FullwidthImage
                image={data.fullwidthImage.childImageSharp.fluid}
              />
            </LazyLoad>
            <LazyLoad offset={200}>
              <CollaborationProcess />
            </LazyLoad>
            <LazyLoad offset={200}>
              <AcrossIndustries allArticles={allArticles} />
            </LazyLoad>
            <ContactFormFullwidth
              name={'fpdc-contact-form'}
              pardotLink={'https://go.boldare.com/l/688533/2019-02-28/x8f'}
            />
            <OurArticles allArticles={allArticles} />
            <OtherServices />
          </div>
        )}
      />
    );
  }
}

export default FullProductDevelopmentCycle;
